import { createContext } from 'react';

interface HubThemingConstants {
  googleFontAPIKey: string;
  externalBaseUrl: string;
}

export interface HubThemingContextType {
  constants: HubThemingConstants;
  themeSettings: Record<string, any>[];
  renderedThemeSettings: Record<string, any>[];
  isLoading: boolean;
  inAdminPreview: boolean;
  inIFramePreview: boolean;
}
export const HubThemingContext = createContext<HubThemingContextType>({
  constants: {
    googleFontAPIKey: '',
    externalBaseUrl: '',
  },
  themeSettings: [],
  renderedThemeSettings: [],
  isLoading: false,
  inAdminPreview: false,
  inIFramePreview: false,
});
